import {CERT_PROP_NAME} from 'common/constants';
import * as Yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';

export const ImportSSHKeyPairNames = {
   filePath: CERT_PROP_NAME,
   keyName: 'keyName',
   overwrite: 'overwrite',
   folderID: 'folderID',

   passphrase: 'passphrase',
   existingPassphrase: 'existingPassphrase',
} as const;

export const importSSHPublicSchema = Yup.object({
   [ImportSSHKeyPairNames.filePath]: Yup.string().required(),
   [ImportSSHKeyPairNames.keyName]: Yup.string().required(),
   [ImportSSHKeyPairNames.overwrite]: Yup.boolean().default(false),
   [ImportSSHKeyPairNames.folderID]: Yup.idString(),
});
export type ImportSSHPublic = Yup.InferType<typeof importSSHPublicSchema>;

export const importSSHKeyPairSchema = importSSHPublicSchema.shape({
   [ImportSSHKeyPairNames.passphrase]: passphrase(),
   [ImportSSHKeyPairNames.existingPassphrase]: Yup.string().oneOf(
      [Yup.ref('passphrase'), null],
      'Passphrase entries do not match'
   ),
});

export type ImportSSHKeyPair = Yup.InferType<typeof importSSHKeyPairSchema>;
